import { Button } from "@/components/ui/button";
import { RotateCcw } from "lucide-react";
import { BTN } from "@/components/common/btn";

// "Restore to draft" — shown for both `cancelled` and `completed` WOs so
// a manager can re-open the WO into the draft pipeline. Neutral (nav)
// colour; the test id differs between the two.
export function WORestoreButton({ variant, onClick }) {
  const testId = variant === "completed"
    ? "btn-restore-completed-draft"
    : "btn-restore-draft";
  return (
    <Button size="sm" className={BTN.nav} onClick={onClick} data-testid={testId}>
      <RotateCcw className="w-3.5 h-3.5 mr-1" /> Restore to draft
    </Button>
  );
}
